<template>
    <v-expansion-panel>
        <v-expansion-panel-header
            color="#f7f7f9"
            data-test-id="wigs--new-wig-properties--top-type--top-type-drop-down-btn"
        >
            <h4 class="order-property__sub-title">
                3. {{ propertiesContent['top-type'] }}
            </h4>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="#f7f7f9">
            <div
                id="order-property--top-type--tpo-type-select"
                class="order-property__input-wrapper"
            >
                <v-autocomplete
                    v-model="mainValue"
                    outlined
                    :items="mainItems"
                    :label="propertiesContent['top-type']"
                    dense
                    attach="#order-property--top-type--tpo-type-select"
                    :error-messages="properties.errors['topType']"
                    data-test-id="wigs--new-wig-properties--top-type--top-type-select"
                    @change="handleMainValueChange"
                    @input="properties.errors['topType'] = ''"
                >
                </v-autocomplete>

                <template v-if="matchesMainValue('Regular Skin')">
                    <v-autocomplete
                        v-model="subValue"
                        outlined
                        :items="subItems['Lace Top']"
                        :label="label(mainValue)"
                        dense
                        attach="#order-property--top-type--tpo-type-select"
                        :error-messages="properties.errors['topType']"
                        data-test-id="wigs--new-wig-properties--top-type--top-type-sub-value-select"
                        @change="changeHandle"
                        @input="properties.errors['topType'] = ''"
                    >
                    </v-autocomplete>

                    <v-autocomplete
                        v-model="additionalValue"
                        outlined
                        :items="subItems[mainValue]"
                        :label="label('Skin Type')"
                        dense
                        attach="#order-property--top-type--tpo-type-select"
                        :error-messages="properties.errors['topType']"
                        data-test-id="wigs--new-wig-properties--top-type--top-type-sub-value-select"
                        @change="changeHandle"
                        @input="properties.errors['topType'] = ''"
                    >
                    </v-autocomplete>
                </template>

                <template v-if="isNotException(['Regular Skin', 'Ribben', 'Kosher Top'])">
                    <v-autocomplete
                        v-model="subValue"
                        outlined
                        :items="subItems[mainValue]"
                        :label="label(mainValue)"
                        dense
                        attach="#order-property--top-type--tpo-type-select"
                        :error-messages="properties.errors['topType']"
                        data-test-id="wigs--new-wig-properties--top-type--top-type-sub-value-select"
                        @change="changeHandle"
                        @input="properties.errors['topType'] = ''"
                    >
                    </v-autocomplete>
                </template>

                <template v-if="matchesMainValue('Lace Top')">
                    <v-text-field
                        v-model="properties.fields['topTypeComments']"
                        light
                        outlined
                        dense
                        type="text"
                        name="lace-top-comment"
                        :label="propertiesContent['lace-top-comment']"
                        :error-messages="properties.errors['laceTopComment']"
                        data-test-id="wigs--new-wig-properties--top-type--top-type-comment-text-input"
                        @input="properties.errors['laceTopComment'] = ''"
                    >
                    </v-text-field>
                </template>

                <template v-if="matchesMainValue('Ribben')">
                    <v-autocomplete
                        v-model="subValue"
                        outlined
                        :items="subItems['Lace Top']"
                        :label="label(mainValue)"
                        dense
                        attach="#order-property--top-type--tpo-type-select"
                        :error-messages="properties.errors['topType']"
                        data-test-id="wigs--new-wig-properties--top-type--top-type-sub-value-select"
                        @change="changeHandle"
                        @input="properties.errors['topType'] = ''"
                    >
                    </v-autocomplete>

                    <v-text-field
                        v-model="properties.fields['topTypeComments']"
                        light
                        outlined
                        dense
                        type="text"
                        name="ribben-comment"
                        :label="propertiesContent['ribben-comment']"
                        :error-messages="properties.errors['RibbenComment']"
                        data-test-id="wigs--new-wig-properties--top-type--top-type-comment-text-input"
                        @input="properties.errors['RibbenComment'] = ''"
                    >
                    </v-text-field>
                </template>

                <template v-if="matchesMainValue('Kosher Top')">
                    <v-autocomplete
                        v-model="subValue"
                        outlined
                        :items="subItems['Lace Top']"
                        :label="label(mainValue)"
                        dense
                        attach="#order-property--top-type--tpo-type-select"
                        :error-messages="properties.errors['topType']"
                        data-test-id="wigs--new-wig-properties--top-type--top-type-sub-value-select"
                        @change="changeHandle"
                        @input="properties.errors['topType'] = ''"
                    >
                    </v-autocomplete>

                    <v-text-field
                        v-model="properties.fields['topTypeComments']"
                        light
                        outlined
                        dense
                        type="text"
                        name="kosher-top-comment"
                        :label="propertiesContent['kosher-top-comment']"
                        :error-messages="properties.errors['KosherTopComment']"
                        data-test-id="wigs--new-wig-properties--top-type--top-type-comment-text-input"
                        @input="properties.errors['KosherTopComment'] = ''"
                    >
                    </v-text-field>
                </template>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import isJson from '@/helpers/isJson'
import { mapGetters, mapActions } from 'vuex'
import { getterTypes } from '@/store/modules/orders'
import languagePropertiesMixin from '@/mixins/language-properties.mixin'
import regularToSnakeCase from '@/helpers/regular-to-snake-case'
import { actionTypes as actionTypesConfirmer } from '@/store/modules/confirmer'
import languageMixin from '../../mixins/language.mixin'

export default {
    name: 'OrderFormPropertyTopType',
    mixins: [languagePropertiesMixin],
    props: {
        dataProperties: {
            type: Object,
            default: () => ({
                fields: {
                    ['topType']: '',
                    ['topTypeComments']: '',
                },
                errors: {},
            }),
        },
        disableProperties: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['onChange'],
    data() {
        return {
            mainValue: null,
            subValue: null,
            additionalValue: null,
        }
    },
    computed: {
        ...mapGetters('orders', { getOrder: getterTypes.getOrder }),
        mainItems: function () {
            return [
                { text: this.propertiesContent['none'], value: null },
                {
                    text: this.propertiesContent['regular-skin'],
                    value: 'Regular Skin',
                },
                {
                    text: this.propertiesContent['lace-top'],
                    value: 'Lace Top',
                },
                {
                    text: this.propertiesContent['ribben'],
                    value: 'Ribben',
                },
                {
                    text: this.propertiesContent['kosher-top'],
                    value: 'Kosher Top',
                },
                {
                    text: this.propertiesContent['weft-top-in-circle'],
                    value: 'Weft Top In Circle',
                },
                {
                    text: this.propertiesContent['skin-heights'],
                    value: 'Skin Heights',
                },
            ]
        },
        subItems: function () {
            return {
                ['Regular Skin']: [
                    { text: this.propertiesContent['none'], value: null },
                    {
                        text: this.propertiesContent['regular'],
                        value: 'Regular',
                    },
                    {
                        text: this.propertiesContent['american'],
                        value: 'American',
                    },
                    { text: this.propertiesContent['fine'], value: 'Fine' },
                ],
                ['Lace Top']: [
                    { text: this.propertiesContent['none'], value: null },
                    {
                        text: this.propertiesContent['straight'],
                        value: 'Straight',
                    },
                    {
                        text: this.propertiesContent['straight-with-body'],
                        value: 'Straight With Body',
                    },
                    {
                        text: this.propertiesContent['very-light-wave'],
                        value: 'Very Light Wave',
                    },
                    {
                        text: this.propertiesContent['light-wave'],
                        value: 'Light Wave',
                    },
                    {
                        text: this.propertiesContent['light-wave-plus'],
                        value: 'Light Wave Plus',
                    },
                    {
                        text: this.propertiesContent['light-with-strong-wave'],
                        value: 'Light Wave Strong Wave',
                    },
                    {
                        text: this.propertiesContent['strong-wave'],
                        value: 'Strong Wave',
                    },
                    {
                        text: this.propertiesContent['curly'],
                        value: 'Curly',
                    },
                ],
                ['Weft Top In Circle']: [
                    { text: this.propertiesContent['none'], value: null },
                    {
                        text: this.propertiesContent['regular'],
                        value: 'Regular',
                    },
                    {
                        text: this.propertiesContent['weft-top-like-fall'],
                        value: 'Weft Top Like Fall',
                    },
                ],
                ['Skin Heights']: [
                    { text: this.propertiesContent['none'], value: null },
                    { text: this.propertiesContent['flat'], value: 'Flat' },
                    {
                        text: this.propertiesContent['with-heights'],
                        value: 'With Heights',
                    },
                ],
            }
        },
        properties: function () {
            return this.dataProperties
        },
        resValue: function () {
            if (this.mainValue === 'Regular Skin') {
                const res = this.regularSkinFunc()
                return res
            }

            if (this.additionalValue) {
                return JSON.stringify([
                    [this.mainValue, this.additionalValue],
                    [this.mainValue, this.subValue],
                ])
            }

            return JSON.stringify([this.mainValue, this.subValue])
        },
        topType: function () {
            return this.properties.fields['topType']
        },
    },
    mounted() {
        setTimeout(() => {
            this.init()
        })
    },
    methods: {
        ...mapActions('confirmer', {
            confirmHandle: actionTypesConfirmer.confirmHandle,
        }),
        label: function (label) {
            return this.propertiesContent[regularToSnakeCase(label)]
        },
        init: function () {
            if (!this['topType'] || !isJson(this.topType)) return null
            const value = JSON.parse(this.topType)

            if (Array.isArray(value[0])) {
                ;[this.mainValue, this.subValue] = value[0]

                this.additionalValue = value[1][1]
                return
            }

            ;[this.mainValue, this.subValue] = value
        },
        changeHandle: function () {
            this.properties.fields['topType'] = this.resValue
            this.clearCommentHandle()
        },
        clearCommentHandle: function () {
            if (this.mainValue === 'Lace Top') return
            this.properties.fields['topTypeComments'] = null
        },
        clearSub: function () {
            this.subValue = null
        },
        cancelLastChanges: function () {
            this.clearFull()
        },
        updateFrontState: function () {
            const details = {
                main: this.mainValue,
                sub: this.subValue,
                cancelLastChanges: this.cancelLastChanges,
            }
            this.$emit('onChange', details)
        },
        handleMainValueChange() {
            this.clearSub()
            this.clearAdditional()
            this.changeHandle()
            this.updateFrontState()
        },
        clearAdditional: function () {
            this.additionalValue = null
        },
        clearFull() {
            this.mainValue = null
            this.subValue = null
            this.additionalValue = null
            this.properties.fields['topType'] = ''
            this.properties.fields['topTypeComments'] = ''
        },
        regularSkinFunc: function () {
            if (this.additionalValue) {
                return JSON.stringify([
                    [this.mainValue, this.subValue],
                    ['Skin Type', this.additionalValue],
                ])
            }

            return JSON.stringify([this.mainValue, this.subValue])
        },
        isNotException: function (exceptions = []) {
            return this.mainValue && !exceptions.includes(this.mainValue)
        },
        matchesMainValue: function (value) {
            return this.mainValue && this.mainValue === value
        },
    },
}
</script>

<style lang="scss" scoped>
.order-property {
    &__sub-title {
        color: $color-primary-dark;
    }

    &__input-wrapper {
        padding: 15px 15px 0;
    }
}
</style>
